import { Loader } from './loader';

export const LoadingScreen = () => {
  return (
    <div className={`loadingScreen`}>
      <Loader />
    </div>
  );
};
